module.exports = __webpack_public_path__ + "img/pic3.7d1e02af.png";